import { render, staticRenderFns } from "./AddressText.vue?vue&type=template&id=62d2d4f8&scoped=true"
import script from "./AddressText.vue?vue&type=script&lang=js"
export * from "./AddressText.vue?vue&type=script&lang=js"
import style0 from "./AddressText.vue?vue&type=style&index=0&id=62d2d4f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d2d4f8",
  null
  
)

export default component.exports